import React from 'react'
import { DropdownItem } from "semantic-ui-react";
import { DropdownMenu } from "semantic-ui-react";
import { Dropdown } from "semantic-ui-react";
import { Transforms } from "slate";
import { ReactEditor } from "slate-react";
import { useSlate } from "slate-react";
import { deserialize } from "./HtmlSerialisation";

export const TemplatesButton = (props) => {
  const editor = useSlate()
  const {templates} = props.useTemplates
  return (
   templates && templates.length > 0 ?
    <Dropdown item text={I18n.t('components.rich_text.add_template')}>
      <DropdownMenu>
        {templates.map(option => {
          return (
            <DropdownItem
              key={`template-option-${option.subject}`}
              onClick={event => {
                event.preventDefault()
                insertTemplate(editor, option)
                ReactEditor.focus(editor)
              }}>{option.subject}</DropdownItem>)
        })}
      </DropdownMenu>
    </Dropdown>
  : null
  )
}

const insertTemplate = (editor, template) => {
  const document = new DOMParser().parseFromString(template.body, 'text/html')
  const nodes = deserialize(document.body)
  Transforms.insertNodes(editor, nodes)
  Transforms.move(editor)
}


